<div class="loading">
	<i class="far fa-fw fa-tire fa-spin"></i>
</div>

<style>
	.loading {
		width: 100%;
		height: 100%;
		min-height: 25rem;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: white;
	}
	.loading i {
		font-size: 5rem;
		color: rgba(0, 0, 0, .8);
	}
</style>